module.exports = __webpack_public_path__ + "img/1.a3675b9c.jpg";